import apiFetch from '../apiFetch'

export default function (token, documentTypeUse) {
  return apiFetch({ endPoint: 'DocumentTypeUse', method: 'POST', body: documentTypeUse, token: token })
}
